import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';
import { SzPillVariant } from './sz-pill.types';

@Component({
  selector: 'sz-pill',
  templateUrl: './sz-pill.component.html',
  styleUrls: ['./sz-pill.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class SzPillComponent {
  readonly variant: InputSignal<SzPillVariant> = input<SzPillVariant>('outline');
}
